import React, { Component } from "react";
import { Link } from "react-router-dom";
import calcularPx from "../calcularPx.js";

const SubmenuProductos = ({ mobile, ocultarMenu }) => {

  return (
    <div 
    style={mobile?
    {
      position: "relative",
      marginLeft: "2%",
      marginRight: "2%",
      top: 20,
      paddingLeft: 25,
      paddingTop: 10,
      paddingBottom: 15,
      paddingRight: 25,
      width: "auto",
      background: "#ffffff",
      borderRadius: 25
    }:
    {
      position: "absolute",
      marginLeft: "-50%",
      //marginRight: "auto",
      top: calcularPx(102),
      width: 270,
      height: "auto",
      display: "flex",
      justifyContent: "space-between",
      background: "#FFFFFF",
      paddingLeft: 30,
      paddingTop: 10,
      paddingBottom: 30,
      paddingRight: 30,
      borderBottomLeftRadius: 25,
      borderBottomRightRadius: 25,
      borderBottom: "solid",
      borderBottomWidth: 1,
      borderBottomColor: "#e5e8e9",
      borderLeft: "solid",
      borderLeftWidth: 1,
      borderLeftColor: "#e5e8e9",
      borderRight: "solid",
      borderRightWidth: 1,
      borderRightColor: "#e5e8e9"
    }}>
      <div>
        <div className="titulo_categoria_submenu">
            Convector
          </div>
        
        <Link
          onClick={ocultarMenu}
          to="/productos/patagonia"
        >
          <div className="categoria_submenu">Patagonia</div>
        </Link>
        <Link
          onClick={ocultarMenu}
          to="/productos/euro"
        >
          <div className="categoria_submenu">Euro</div>
        </Link>
        <Link
          onClick={ocultarMenu}
          to="/productos/movil"
        >
          <div className="categoria_submenu">Móvil</div>
        </Link>
        <Link
          onClick={ocultarMenu}
          to="/productos/vitroconvector"
        >
          <div className="categoria_submenu">Vitroconvector</div>
        </Link>

        <div style={{width: "100%", marginTop: 10, marginBottom: 10, height: 1, backgroundColor: "#5B5D61"}}/>
        
        <div className="titulo_categoria_submenu">
          Agua caliente
        </div>
        
        <Link
          onClick={ocultarMenu}
          to="/productos/termotanquesGas"
        >
          <div className="subtitulo_categoria_submenu">
            Termotanque Gas
          </div>
        </Link>
        <Link
          onClick={ocultarMenu}
          to="/productos/termotanquesGas?rs=true"
        >
          <div className="categoria_submenu">Recuperación simultanea</div>
        </Link>
        <Link
          onClick={ocultarMenu}
          to="/productos/termotanquesGas?ar=true"
        >
          <div className="categoria_submenu">Alta recuperación TAR</div>
        </Link>
        <Link
          onClick={ocultarMenu}
          to="/productos/termotanquesElectricos"
        >
          <div className="subtitulo_categoria_submenu">
            Termotanque eléctrico
          </div>
        </Link>
        <Link
          onClick={ocultarMenu}
          to="/productos/termotanquesElectricos"
        >
          <div className="categoria_submenu">TTQE</div>
        </Link>
        <div style={{width: "100%", marginTop: 10, marginBottom: 10, height: 1, backgroundColor: "#5B5D61"}}/>
        
        <div className="titulo_categoria_submenu">
          Cocción
        </div>
        
        <Link
          onClick={ocultarMenu}
          to="/productos/hornosElectricos"
        >
          <div className="categoria_submenu">Hornos</div>
        </Link>
        <Link
          onClick={ocultarMenu}
          to="/productos/anafes"
        >
          <div className="categoria_submenu">Anafes</div>
        </Link>
        <Link
          onClick={ocultarMenu}
          to="/productos/campanas"
        >
          <div className="categoria_submenu">Campanas</div>
        </Link>
      </div>
    </div>
  );
};

export default SubmenuProductos;
